import { Platform, StyleSheet } from "react-native";

const optStyles = StyleSheet.create({
  wrap: {
    marginTop: 10,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: "#DFDFDF",
    borderStyle: "dashed",
  },
  label: {
    fontSize: 11,
    fontWeight: "600",
    color: "#585858",
    marginBottom: 6,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  chipList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
    marginBottom: 8,
  },
  empty: {
    fontSize: 12,
    color: "#A8A8A8",
    fontStyle: "italic",
  },
  chip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 100,
    paddingLeft: 12,
    paddingRight: 4,
    paddingVertical: 4,
  },
  chipText: {
    fontSize: 12,
    color: "#3A3A3A",
  },
  chipRemove: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: "#EBEBEB",
    alignItems: "center",
    justifyContent: "center",
  },
  addRow: {
    flexDirection: "row",
    gap: 8,
  },
  addInput: {
    flex: 1,
    maxWidth: 260,
    height: 34,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 6,
    paddingHorizontal: 10,
    fontSize: 13,
    color: "#2D2D2D",
    backgroundColor: "white",
  },
  addBtn: {
    paddingHorizontal: 12,
    paddingVertical: 0,
    height: 34,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 6,
    backgroundColor: "#F8F8F8",
    justifyContent: "center",
  },
  addBtnText: {
    fontSize: 13,
    fontWeight: "500",
    color: "#034895",
  },
});

const skeletonStyles = StyleSheet.create({
  row: {
    borderWidth: 1,
    borderColor: "#E6E6E6",
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    backgroundColor: "#F8F8F8",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  badge: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: "#DDE9FB",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  badgeText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#8FA9D8",
  },
  block: {
    height: 36,
    borderRadius: 6,
    backgroundColor: "#E6EEF9",
  },
  fieldTitle: {
    flex: 2,
    minWidth: 0,
  },
  typeSelect: {
    flex: 1,
    maxWidth: 160,
  },
  requiredSelect: {
    flex: 1,
    maxWidth: 160,
  },
  deleteBtn: {
    width: 32,
  },
});

const rowStyles = StyleSheet.create({
  wrap: {
    borderWidth: 1,
    borderColor: "#E6E6E6",
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    backgroundColor: "#F8F8F8",
  },
  top: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 8,
    flexWrap: "wrap",
  },
  badge: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: "#C6DCFB",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  badgeText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#034895",
  },
  headerTextWrap: {
    flex: 1,
    minWidth: 180,
  },
  headerTitle: {
    fontSize: 13,
    fontWeight: "700",
    color: "#2D2D2D",
  },
  headerMeta: {
    marginTop: 2,
    fontSize: 11,
    color: "#818181",
  },
  headerBadges: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  typeBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 100,
    backgroundColor: "#E8F0FB",
  },
  typeBadgeText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#034895",
  },
  requiredBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 100,
    backgroundColor: "#F3F4F6",
  },
  requiredBadgeOn: {
    backgroundColor: "#FFF1E8",
  },
  requiredBadgeText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#656565",
  },
  requiredBadgeTextOn: {
    color: "#B54708",
  },
  body: {
    marginTop: 12,
    gap: 12,
  },
  fieldBlock: {
    gap: 6,
  },
  requiredControl: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 32,
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: "#585858",
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  requiredMark: {
    color: "#D32F2F",
  },
  textInput: {
    minHeight: 36,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 6,
    paddingHorizontal: 10,
    fontSize: 13,
    color: "#2D2D2D",
    backgroundColor: "white",
    minWidth: 0,
  },
  textInputLocked: {
    backgroundColor: "#F6F8FB",
    color: "#656565",
  },
  helperText: {
    fontSize: 11,
    color: "#818181",
  },
  errorText: {
    fontSize: 11,
    color: "#B42318",
  },
  typeWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  typeChip: {
    paddingHorizontal: 10,
    paddingVertical: 7,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 999,
    backgroundColor: "white",
  },
  typeChipActive: {
    borderColor: "#034895",
    backgroundColor: "#E8F0FB",
  },
  typeChipText: {
    fontSize: 12,
    color: "#2D2D2D",
    fontWeight: "600",
  },
  typeChipTextActive: {
    color: "#034895",
  },
  inlineRow: {
    flexDirection: "row",
    gap: 4,
  },
  inlineField: {
    flex: 1,
    minWidth: 200,
  },
  deleteBtn: {
    width: 32,
    height: 32,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#FFE5DE",
    backgroundColor: "#FFF7F5",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  deleteBtnDisabled: {
    opacity: 0.45,
  },
  textArea: {
    minHeight: 72,
    textAlignVertical: "top",
    paddingTop: 10,
  },
});

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.45)",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    backgroundColor: "white",
    borderRadius: 10,
    width: "100%",
    maxWidth: 680,
    maxHeight: "82%",
    ...Platform.select({
      web: { display: "flex", flexDirection: "column" },
    }),
  },
  header: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#E6E6E6",
  },
  title: {
    fontSize: 16,
    fontWeight: "600",
    color: "#01346F",
    marginBottom: 2,
  },
  subtitle: {
    fontSize: 12,
    color: "#818181",
    marginTop: 2,
  },
  closeButton: {
    width: 32,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
  },
  body: {
    flex: 1,
    paddingHorizontal: 20,
    paddingTop: 14,
    paddingBottom: 4,
    overflow: "hidden",
  },
  toolbar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 14,
  },
  count: {
    fontSize: 12,
    fontWeight: "600",
    color: "#656565",
  },
  errorBanner: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    backgroundColor: "#FEF3F2",
    borderWidth: 1,
    borderColor: "#FECACA",
    marginBottom: 12,
  },
  errorBannerText: {
    flex: 1,
    fontSize: 12,
    color: "#B42318",
  },
  addButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    paddingHorizontal: 12,
    paddingVertical: 7,
    backgroundColor: "#F8F8F8",
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 6,
  },
  addButtonDisabled: {
    opacity: 0.5,
  },
  addButtonText: {
    fontSize: 12,
    fontWeight: "500",
    color: "#034895",
  },
  addButtonTextDisabled: {
    color: "#A8A8A8",
  },
  fieldsList: {
    flex: 1,
  },
  fieldsListContent: {
    paddingBottom: 8,
  },
  emptyState: {
    paddingVertical: 24,
    paddingHorizontal: 8,
  },
  emptyText: {
    fontSize: 13,
    color: "#818181",
    textAlign: "center",
    lineHeight: 20,
  },
  skeletonWrap: {
    paddingTop: 2,
  },
  skeletonHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 14,
  },
  skeletonLine: {
    height: 12,
    borderRadius: 999,
    backgroundColor: "#E6EEF9",
  },
  skeletonHeaderLine: {
    width: 150,
  },
  skeletonChip: {
    width: 112,
    height: 28,
    borderRadius: 6,
    backgroundColor: "#E6EEF9",
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: "#E6E6E6",
    gap: 12,
  },
  button: {
    paddingHorizontal: 20,
    paddingVertical: 9,
    borderRadius: 6,
    minWidth: 90,
    justifyContent: "center",
    alignItems: "center",
  },
  cancelButton: {
    backgroundColor: "transparent",
    borderWidth: 0,
  },
  cancelButtonText: {
    color: "#585858",
    fontSize: 14,
    fontWeight: "500",
  },
  saveButton: {
    backgroundColor: "#034895",
    borderRadius: 6,
  },
  saveButtonDisabled: {
    opacity: 0.45,
  },
  saveButtonText: {
    color: "white",
    fontSize: 14,
    fontWeight: "500",
  },
  dialogBackdrop: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,0.35)",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
  },
  dialog: {
    width: "100%",
    maxWidth: 380,
    backgroundColor: "white",
    borderRadius: 10,
    paddingHorizontal: 20,
    paddingVertical: 18,
  },
  dialogTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#2D2D2D",
    textAlign: "center",
    marginBottom: 10,
  },
  dialogMessage: {
    fontSize: 14,
    lineHeight: 20,
    color: "#666666",
    textAlign: "center",
    marginBottom: 20,
  },
  dialogActions: {
    flexDirection: "row",
    gap: 12,
    justifyContent: "center",
  },
  dialogButton: {
    flex: 1,
    minWidth: 0,
    minHeight: 42,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
  },
  dialogButtonGhost: {
    backgroundColor: "#F5F5F5",
    borderWidth: 1,
    borderColor: "#DDDDDD",
  },
  dialogButtonGhostText: {
    color: "#333333",
    fontSize: 14,
    fontWeight: "600",
  },
  dialogButtonDanger: {
    backgroundColor: "#D32F2F",
  },
  dialogButtonDangerText: {
    color: "white",
    fontSize: 14,
    fontWeight: "600",
  },
});

export { optStyles, rowStyles, skeletonStyles, styles };
export default styles;
